import { Issue } from '../../issue/issue.dto';
import { IndexedService, ISSUES_STORE } from '@damofire/data-commons';
import { NetworkService } from '@damofire/data-angular-commons';
import { Injectable } from '@angular/core';
import { RemoteService } from './remote.service';
import { FirebaseIssueService } from '../../issue/firebase-issue.service';

@Injectable()
export class IssueRemoteService extends RemoteService<Issue> {
  constructor(
    protected readonly idbService: IndexedService,
    protected readonly networkService: NetworkService,
    private readonly firebaseIssueService: FirebaseIssueService,
  ) {
    super(ISSUES_STORE, idbService, networkService);
  }

  async add(division: string, data: Issue[]): Promise<void> {
    await this.firebaseIssueService.createBatch(division, data);
  }

  async delete(division: string, data: Issue[]): Promise<void> {
    await this.firebaseIssueService.delete(division, data);
  }

  async update(division: string, issues: Issue[]): Promise<void> {
    await this.firebaseIssueService.updateBatch(issues);
  }
}
